import {
  OverlayUtil,
  rangeIntersection
} from "@tldraw/editor";
class SnapIndicatorOverlayUtil extends OverlayUtil {
  static type = "snap_indicator";
  options = { zIndex: 500, lineWidth: 1 };
  isActive() {
    return this.editor.snaps.getIndicators().length > 0;
  }
  getOverlays() {
    return this.editor.snaps.getIndicators().map((line) => ({
      id: `snap:${line.id}`,
      type: "snap_indicator",
      props: { line }
    }));
  }
  render(ctx, overlays) {
    const zoom = this.editor.getZoomLevel();
    const snapColor = this.editor.getCurrentTheme().colors[this.editor.getColorMode()].snap;
    for (const overlay of overlays) {
      const { line } = overlay.props;
      if (line.type === "points") {
        this._renderPoints(ctx, line, zoom, snapColor);
      } else if (line.type === "gaps") {
        this._renderGaps(ctx, line, zoom, snapColor);
      }
    }
  }
  _renderPoints(ctx, indicator, zoom, color) {
    const { points } = indicator;
    if (points.length === 0) return;
    const l = 2.5 / zoom;
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for (const point of points) {
      if (point.x < minX) minX = point.x;
      if (point.x > maxX) maxX = point.x;
      if (point.y < minY) minY = point.y;
      if (point.y > maxY) maxY = point.y;
    }
    let useNWtoSEdirection = false;
    for (const point of points) {
      if (point.x === minX && point.y === minY) {
        useNWtoSEdirection = true;
        break;
      }
    }
    let firstX, firstY, secondX, secondY;
    if (useNWtoSEdirection) {
      firstX = minX;
      firstY = minY;
      secondX = maxX;
      secondY = maxY;
    } else {
      firstX = minX;
      firstY = maxY;
      secondX = maxX;
      secondY = minY;
    }
    ctx.strokeStyle = color;
    ctx.lineWidth = this.options.lineWidth / zoom;
    ctx.beginPath();
    ctx.moveTo(firstX, firstY);
    ctx.lineTo(secondX, secondY);
    ctx.stroke();
    ctx.beginPath();
    for (const p of points) {
      ctx.moveTo(p.x - l, p.y - l);
      ctx.lineTo(p.x + l, p.y + l);
      ctx.moveTo(p.x - l, p.y + l);
      ctx.lineTo(p.x + l, p.y - l);
    }
    ctx.stroke();
  }
  _renderGaps(ctx, indicator, zoom, color) {
    const { gaps, direction } = indicator;
    if (gaps.length === 0) return;
    const l = 3.5 / zoom;
    const tickLength = 2 * l;
    const horizontal = direction === "horizontal";
    let edgeIntersection = [-Infinity, Infinity];
    let nextEdgeIntersection = null;
    for (const gap of gaps) {
      nextEdgeIntersection = rangeIntersection(
        edgeIntersection[0],
        edgeIntersection[1],
        horizontal ? gap.startEdge[0].y : gap.startEdge[0].x,
        horizontal ? gap.startEdge[1].y : gap.startEdge[1].x
      );
      if (nextEdgeIntersection) {
        edgeIntersection = nextEdgeIntersection;
      } else {
        continue;
      }
      nextEdgeIntersection = rangeIntersection(
        edgeIntersection[0],
        edgeIntersection[1],
        horizontal ? gap.endEdge[0].y : gap.endEdge[0].x,
        horizontal ? gap.endEdge[1].y : gap.endEdge[1].x
      );
      if (nextEdgeIntersection) {
        edgeIntersection = nextEdgeIntersection;
      } else {
        continue;
      }
    }
    const midPoint = (edgeIntersection[0] + edgeIntersection[1]) / 2;
    ctx.strokeStyle = color;
    ctx.lineWidth = this.options.lineWidth / zoom;
    ctx.beginPath();
    for (const { startEdge, endEdge } of gaps) {
      if (horizontal) {
        ctx.moveTo(startEdge[0].x, midPoint - tickLength);
        ctx.lineTo(startEdge[1].x, midPoint + tickLength);
        ctx.moveTo(endEdge[0].x, midPoint - tickLength);
        ctx.lineTo(endEdge[1].x, midPoint + tickLength);
        ctx.moveTo(startEdge[0].x, midPoint);
        ctx.lineTo(endEdge[0].x, midPoint);
        const cx = (startEdge[0].x + endEdge[0].x) / 2;
        ctx.moveTo(cx, midPoint - l);
        ctx.lineTo(cx, midPoint + l);
      } else {
        ctx.moveTo(midPoint - tickLength, startEdge[0].y);
        ctx.lineTo(midPoint + tickLength, startEdge[1].y);
        ctx.moveTo(midPoint - tickLength, endEdge[0].y);
        ctx.lineTo(midPoint + tickLength, endEdge[1].y);
        ctx.moveTo(midPoint, startEdge[0].y);
        ctx.lineTo(midPoint, endEdge[0].y);
        const cy = (startEdge[0].y + endEdge[0].y) / 2;
        ctx.moveTo(midPoint - l, cy);
        ctx.lineTo(midPoint + l, cy);
      }
    }
    ctx.stroke();
  }
}
export {
  SnapIndicatorOverlayUtil
};
//# sourceMappingURL=SnapIndicatorOverlayUtil.mjs.map
